/**
 * nt-categories-browser.js
 * Drives [data-nt-categories-browser]. Category cards (label/desc/image) come
 * from window.NT.SignCategories and which type IDs belong to each one comes
 * from window.ntSignData.CATEGORY_TYPE_MAP; the rich per-type detail (images,
 * gallery, tags) comes from window.ntSignData.TYPE_LIB — all from the single
 * canonical assets/nt-sign-data.js file.
 */
(function () {
  'use strict';

  function init(root) {
    if (root.dataset.ntBound) return;
    root.dataset.ntBound = 'true';

    var typeLib = (window.ntSignData && window.ntSignData.TYPE_LIB) || {};
    var typeMap = (window.ntSignData && window.ntSignData.CATEGORY_TYPE_MAP) || {};
    /* 'open-face-neon' no longer belongs to any category (dropped from Corporate
       Signage), so it's excluded here too, otherwise it would show as an orphan
       card with no home category. */
    var allTypeIds = Object.keys(typeLib).filter(function (id) { return id !== 'open-face-neon' && !typeLib[id].catOnly; });

    var cats = ((window.NT && window.NT.SignCategories && window.NT.SignCategories.all()) || []).map(function (cat) {
      return {
        label: cat.name,
        sub: cat.sub || '',
        imgAlt: cat.imgAlt || '',
        desc: cat.desc,
        listDesc: cat.listDesc || cat.desc,
        img: cat.img,
        slug: cat.slug,
        typeIds: typeMap[cat.slug] || []
      };
    });
    cats.push({
      label: 'All Signs',
      sub: '',
      desc: 'Browse all ' + allTypeIds.length + ' sign types and find the perfect fit for your brand.',
      img: (typeLib['front-lit'] || {}).img || '',
      slug: '',
      typeIds: allTypeIds
    });

    var catGrid = root.querySelector('[data-nt-cat-grid-inner]');
    var gridView = root.querySelector('[data-nt-cat-grid]');
    var listView = root.querySelector('[data-nt-cat-list]');
    var backBtn = root.querySelector('[data-nt-cat-back]');
    var listBand = root.querySelector('[data-nt-cat-list-band]');
    var listName = root.querySelector('[data-nt-cat-list-name]');
    var listHeading = root.querySelector('[data-nt-cat-list-heading]');
    var listDesc = root.querySelector('[data-nt-cat-list-desc]');
    var listGrid = root.querySelector('[data-nt-cat-list-grid]');

    function catCard(cat, i) {
      return (
        '<button type="button" class="nt-qcat" data-nt-cat-card data-idx="' + i + '">' +
        '<span class="nt-qcat-img"><img src="' + cat.img + '" alt="' + escapeHtml(cat.imgAlt || cat.label) + '" loading="lazy">' +
        '<span class="nt-qcat-count"><b>' + cat.typeIds.length + '</b> Sign types</span>' +
        '<span class="nt-qcat-ov">' + escapeHtml(cat.label) + '</span></span>' +
        '<span class="nt-qcat-idx">' + String(i + 1).padStart(2, '0') + '</span>' +
        '<span class="nt-qcat-info">' +
        '<h3 class="nt-qcat-n">' + escapeHtml(cat.label) + '</h3>' +
        (cat.sub ? '<span class="nt-qcat-sub">' + escapeHtml(cat.sub) + '</span>' : '') +
        '<p class="nt-qcat-d">' + escapeHtml(cat.desc) + '</p>' +
        '<span class="nt-qcat-explore"><span class="nt-qcat-e-d">Explore Sign</span><span class="nt-qcat-e-m">Explore types <i>&rarr;</i></span></span>' +
        '</span>' +
        '</button>'
      );
    }

    function typeCard(id, mode) {
      var t = typeLib[id];
      if (!t) return '';
      var badge = t.lit ? 'Lit' : 'Non-Lit';
      var badgeCls = t.lit ? '' : 'non';
      var tags = (t.tags || []).map(function (tag) {
        return '<span class="nt-qtype-tag">' + escapeHtml(tag) + '</span>';
      }).join('');
      return (
        '<div class="nt-qtype" data-type-id="' + id + '">' +
        '<span class="nt-qtype-img"><img src="' + t.img + '" alt="' + escapeHtml(t.alt || t.label) + '" loading="lazy">' +
        '<span class="nt-qtype-badge ' + badgeCls + '">' + badge + '</span></span>' +
        '<h3 class="nt-qtype-n">' + escapeHtml(t.label) + '</h3>' +
        '<p class="nt-qtype-d">' + escapeHtml(t.desc) + '</p>' +
        '<div class="nt-qtype-tags">' + tags + '</div>' +
        '<div class="nt-qtype-actions">' +
        '<button type="button" class="nt-qtype-view" data-action="view">' + iconEye() + 'More Photos</button>' +
        '<button type="button" class="nt-qtype-quote" data-action="quote">Get Quote</button>' +
        '</div>' +
        '</div>'
      );
    }

    function iconEye() {
      return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path><circle cx="12" cy="12" r="3"></circle></svg>';
    }

    function escapeHtml(str) {
      var div = document.createElement('div');
      div.textContent = str || '';
      return div.innerHTML;
    }

    function showGrid() {
      gridView.hidden = false;
      listView.hidden = true;
      gridView.classList.remove('nt-slide-r');
      void gridView.offsetWidth;
      gridView.classList.add('nt-slide-l');
    }

    var activeCategoryLabel = '';

    function showList(cat) {
      var ids = cat.typeIds;
      activeCategoryLabel = cat.label;
      if (listName) listName.textContent = cat.label;
      if (listHeading) listHeading.textContent = cat.label;
      if (listDesc) listDesc.textContent = cat.listDesc || cat.desc;
      if (listBand) listBand.className = 'nt-cat-list-band' + (cat.slug ? ' nt-cat--' + cat.slug : '');
      listGrid.innerHTML = ids.map(function (id) { return typeCard(id, 'detail'); }).join('');
      gridView.hidden = true;
      listView.hidden = false;
      listView.classList.remove('nt-slide-l');
      void listView.offsetWidth;
      listView.classList.add('nt-slide-r');
      bindTypeActions();
    }

    function bindTypeActions() {
      listGrid.querySelectorAll('[data-action="view"]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var card = btn.closest('[data-type-id]');
          var t = typeLib[card.getAttribute('data-type-id')];
          if (!t) return;
          document.dispatchEvent(new CustomEvent('nt:lightbox-open', {
            detail: { title: t.label, images: t.gallery || [t.img], quoteType: t.label, quoteCategory: activeCategoryLabel }
          }));
        });
      });
      listGrid.querySelectorAll('[data-action="quote"]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var card = btn.closest('[data-type-id]');
          var t = typeLib[card.getAttribute('data-type-id')];
          if (!t) return;
          document.dispatchEvent(new CustomEvent('nt:request-quote-drawer', { detail: { type: t.label, category: activeCategoryLabel } }));
        });
      });
    }

    if (catGrid) {
      catGrid.innerHTML = cats.map(catCard).join('');
      catGrid.querySelectorAll('[data-nt-cat-card]').forEach(function (card) {
        card.addEventListener('click', function () { showList(cats[Number(card.getAttribute('data-idx'))]); });
      });
    }

    if (backBtn) backBtn.addEventListener('click', showGrid);
  }

  document.querySelectorAll('[data-nt-categories-browser]').forEach(init);
  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('[data-nt-categories-browser]').forEach(init);
  });
})();